import React, { useState } from 'react';
import { Play, ExternalLink } from 'lucide-react';

const VideoLessonsHub = () => {
  const [isPlaying, setIsPlaying] = useState(false);

  return (
    <div className="glass-panel p-6 sm:p-8 rounded-3xl space-y-4">
      <div className="flex items-center justify-between border-b border-white/10 pb-3">
        <div>
          <div className="text-[10px] font-bold uppercase tracking-widest text-white/50">
            Видеолекции и разборы
          </div>
          <h3 className="text-base font-bold text-white mt-0.5">
            Практикум по прикладной разработке и Python
          </h3>
        </div>

        <a 
          href="https://www.youtube.com/playlist?list=PLDyJYA6aTY1lPWXBPk0gw6gR8fEtPDGKa" 
          target="_blank" 
          rel="noopener noreferrer"
          className="glass-btn-secondary px-3.5 py-1.5 rounded-xl text-xs uppercase tracking-wider flex items-center gap-1.5"
        >
          <span>Плейлист</span>
          <ExternalLink className="w-3.5 h-3.5" />
        </a>
      </div>

      <div className="relative aspect-video rounded-2xl overflow-hidden glass-panel-subtle border border-white/10 bg-[#090314]">
        {isPlaying ? (
          <iframe 
            width="100%" 
            height="100%" 
            src="https://www.youtube-nocookie.com/embed/videoseries?list=PLDyJYA6aTY1lPWXBPk0gw6gR8fEtPDGKa&autoplay=1" 
            title="Study Platform Video Courses" 
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
            allowFullScreen
            className="w-full h-full border-0"
          />
        ) : (
          <div className="w-full h-full flex flex-col items-center justify-center p-6 text-center space-y-4">
            <div className="w-14 h-14 rounded-full bg-white text-[#07030e] flex items-center justify-center shadow-xl shadow-white/20">
              <Play className="w-6 h-6 ml-0.5 fill-current" />
            </div>
            <div>
              <div className="text-sm font-bold text-white">Видеокурс: От базового синтаксиса до API и FinTech</div>
              <div className="text-xs text-white/50 mt-1 max-w-md">
                Интерактивные видеоуроки Study Platform. Запустите плеер прямо в платформе или откройте внешний плейлист.
              </div>
            </div>
            <button
              type="button"
              onClick={() => setIsPlaying(true)}
              className="glass-btn-primary px-5 py-2 rounded-xl text-xs uppercase tracking-wider"
            >
              Смотреть курс
            </button>
          </div>
        )}
      </div>

      <div className="text-xs text-white/60 leading-relaxed">
        Теоретический и практический видеоматериал для подготовки к сдаче сертификационных нормативов и аттестационных собеседований.
      </div>
    </div>
  );
};

export default VideoLessonsHub;
